import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { LogOut, User } from "react-feather";
import { useHistory } from "react-router";
import { translate } from "react-switch-lang";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import man from "../../assets/images/dashboard/profile.jpg";
import { Role } from "../../models/roleDto";
import Translate from "../translate/translate";
import hasRoles from "../../security/hasRoles";
import AgrisudLogo from "../../assets/images/logo/logo-agrisud-cropped2.jpg";
import styles from "./rightbar.module.scss";
import { useSelector } from "react-redux";

const Rightbar = props => {
  const [name, setName] = useState("");
  const [mainRole, setMainRole] = useState();
  const [setMoonlight] = useState(false);
  const keycloak = useKeycloak().keycloak;
  const history = useHistory();
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const currentLang = useSelector(state => state.language.currentLang);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const redirectHome = () => {
    const isAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
    if (isAdmin) {
      history.push("/training-paths");
    } else {
      history.push("/");
    }
  };

  useEffect(() => {
    setName(localStorage.getItem("Name"));
    if (localStorage.getItem("layout_version") === "dark-only") {
      setMoonlight(true);
    }
    if (keycloak.authenticated) {
      keycloak.loadUserInfo().then(info => {
        setName(info.name);
        setMainRole(keycloak.hasResourceRole("ROLE_ELEARNING_ADMIN") ? Role.ROLE_ELEARNING_ADMIN : Role.ROLE_ELEARNING_USER);
      });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles["agrisud-navbar"]}>
      {(!hasRoleAdmin || window.outerWidth <= 992) && (
        <div className={styles["agrisud-nav-menus-logo"]}>
          <a href={currentLang === "fr" ? "https://www.agrisud.org/web" : "https://www.agrisud.org/web/en"} target="_blank" rel="noreferrer">
            <img className={styles["nav-image"]} src={AgrisudLogo} alt="" />
          </a>
        </div>
      )}

      <div className={`nav-right ${styles["agrisud-navbar-items"]} right-header`}>
        <ul className={`${styles["agrisud-nav-menus"]} nav-menus`}>
          <li className="language-nav">
            <Translate />
          </li>
          {keycloak.authenticated && window.outerWidth > 922 && (
            <li className="profile-nav onhover-dropdown p-0">
              <div className={`${styles["custom-media"]} media profile-media`}>
                <img className="b-r-10" src={man} alt="" />
                <div className="media-body">
                  <span>{keycloak.authenticated ? name : "name"}</span>
                  <p className="mb-0 font-roboto">
                    {props.t(mainRole + "")} <i className="middle fa fa-angle-down"></i>
                  </p>
                </div>
              </div>
              <ul className="profile-dropdown onhover-show-div">
                <li onClick={() => (window.location = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/agrisud/account/#/`)}>
                  <User />
                  <span>{props.t("auth_profile")}</span>
                </li>
                <li
                  onClick={() => {
                    history.push("/");
                    keycloak.logout();
                  }}
                >
                  <LogOut />
                  <span>{props.t("auth_logout")}</span>
                </li>
              </ul>
            </li>
          )}
          {!keycloak.authenticated && window.outerWidth > 992 && (
            <li onClick={() => history.push("/training-paths")} className={styles["agrisud-navbar-login"]}>
              <Button outline color="success">
                <span>{props.t("login")}</span>
              </Button>
            </li>
          )}
        </ul>
        <div className={styles["agrisud-navbar-links"]}>
          <div onClick={redirectHome} className={hasRoleAdmin ? styles["agrisud-admin-navbar-links-slugan"] : styles["agrisud-navbar-links-slugan"]}>
            <h5 className={styles["agrisud-navbar-slugan"]}>E-learning</h5>
          </div>
          {window.outerWidth > 992 ? (
            <div className={styles["agrisud-navbar-links-items"]}>
              <div className={styles["agrisud-navbar-links-item"]}>
                <a href={"https://www.agrisud.org/mediatheque/"} target="_blank" rel="noreferrer">
                  <span>{props.t("Media_library")}</span>
                </a>
              </div>
              <div className={styles["agrisud-navbar-links-item"]}>
                <a href={currentLang === "fr" ? "https://www.agrisud.org/web" : "https://www.agrisud.org/web/en"} target="_blank" rel="noreferrer">
                  <span>Agrisud.org</span>
                </a>
              </div>
              <div>
                <span className={styles["agrisud-navbar-aide"]} onClick={toggle}>
                  {props.t("help")}
                </span>
              </div>
            </div>
          ) : (
            <>
              <input className={styles["toggle-menu"]} id="toggle-menu" type="checkbox" />
              <nav className={styles["nav-vertical-menu"]}>
                <ul>
                  {!keycloak.authenticated && (
                    <li onClick={() => history.push("/training-paths")} className={styles["agrisud-navbar-login"]}>
                      <span>{props.t("login")}</span>
                    </li>
                  )}
                  {hasRoleAdmin && (
                    <>
                      <li onClick={() => history.push("/training-paths")}>
                        <span>{props.t("training_path_list")}</span>
                      </li>
                      <li onClick={() => history.push("/training-paths/archive")}>
                        <span>{props.t("archived_training_path_list")}</span>
                      </li>
                      <li onClick={() => history.push("/training-paths/statistics")}>
                        <span>{props.t("statistics")}</span>
                      </li>
                    </>
                  )}
                  <li>
                    <a color="black" href={"https://www.agrisud.org/mediatheque/"} target="_blank" rel="noreferrer">
                      {props.t("Media_library")}
                    </a>
                  </li>
                  <li>
                    <a href={currentLang === "fr" ? "https://www.agrisud.org/web" : "https://www.agrisud.org/web/en"} target="_blank" rel="noreferrer">
                      Agrisud.org
                    </a>
                  </li>
                  <li>
                    <span onClick={toggle}>{props.t("help")}</span>
                  </li>
                  {keycloak.authenticated && (
                    <>
                      {/* <li onClick={() => (window.location = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/agrisud/account/#/`)}> */}
                      <li onClick={() => history.push(`/training-paths`)}>
                        <User />
                        <span className="m-l-5">{props.t("auth_profile")}</span>
                      </li>
                      <li
                        onClick={() => {
                          history.push("/");
                          keycloak.logout();
                        }}
                      >
                        <LogOut />
                        <span className="m-l-5">{props.t("auth_logout")}</span>
                      </li>
                    </>
                  )}
                </ul>
              </nav>
              <label className={styles["button-toggle-menu"]} htmlFor="toggle-menu">
                <i className="fa fa-bars"></i>
              </label>
              <label className={styles["overlay"]} htmlFor="toggle-menu"></label>
            </>
          )}
        </div>
      </div>

      <Modal className={styles["modal-aide"]} isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{props.t("help")}</ModalHeader>
        <ModalBody>
          {props.t("help-text")}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Fermer
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default translate(Rightbar);
